import { StatusTypes } from '@grin-rnd/grin-api-sdk/dist/Enums/Statuses'

export const buildActiveBriefPatientsFilter = ({ accountOwnerId, hasPatientBrief }) => ({
  doctorId: { eq: accountOwnerId },
  statusType: { eq: StatusTypes.ActiveTreatment },
  ...(typeof hasPatientBrief === 'boolean' ? { hasPatientBrief: { eq: hasPatientBrief } } : {})
})

// Unindexed patients are unknown, not patients with missing briefs.
export const isBriefCoverageComplete = coverage =>
  !!coverage && coverage.patientsWithBrief + coverage.patientsWithoutBrief === coverage.activePatients

export const calculateCopilotUtilization = ({ practiceGuidelinesConfiguration = [], briefCoverage }) => {
  const enabledCategories = practiceGuidelinesConfiguration.filter(category => category.isEnabled).length
  const practiceCoverage = practiceGuidelinesConfiguration.length
    ? enabledCategories / practiceGuidelinesConfiguration.length
    : 0
  const patientCoverage = briefCoverage?.activePatients
    ? briefCoverage.patientsWithBrief / briefCoverage.activePatients
    : 0
  return Math.round(practiceCoverage * 30 + patientCoverage * 70)
}
